import { useState } from 'react'

import { useAddresses } from '@/api/addresses/queries/useAddresses'
import type { Address } from '@/api/addresses/types/Address'
import AddIcon from '@/Components/icons/add.svg?react'
import { Button } from '@/Components/ui/button'
import { Card, CardContent } from '@/Components/ui/card'
import { Spinner } from '@/Components/ui/spinner'

import { AddressPreview } from './AddressPreview'
import EditAddressDialog from './EditAddressDialog'

export default function ProfileAddressPage() {
  const { data: addresses = [], isLoading } = useAddresses()

  const [isAddressDialogOpen, setIsAddressDialogOpen] = useState(false)
  const [editingAddress, setEditingAddress] = useState<Address | null>(null)

  const handleOpenAddAddress = () => {
    setEditingAddress(null)
    setIsAddressDialogOpen(true)
  }

  const handleOpenEditAddress = (address: Address) => {
    setEditingAddress(address)
    setIsAddressDialogOpen(true)
  }

  const handleAddressDialogSuccess = () => {
    setEditingAddress(null)
  }

  const defaultAddress = addresses.find(address => address.isDefault) || addresses[0]

  const otherAddresses = addresses.filter(address => address.id !== defaultAddress.id)
  if (isLoading) {
    return (
      <Card>
        <CardContent>
          <Spinner className='mx-auto size-10' />
        </CardContent>
      </Card>
    )
  }
  return (
    <div className='space-y-4'>
      {addresses.length === 0 ? (
        <div className='text-text-secondary py-8 text-center'>
          אין כתובות.{' '}
          <button onClick={handleOpenAddAddress} className='text-text-link cursor-pointer'>
            הוסף כתובת חדשה כדי להתחיל.
          </button>
        </div>
      ) : (
        <>
          {defaultAddress && <AddressPreview address={defaultAddress} onEdit={() => handleOpenEditAddress(defaultAddress)} />}
          {otherAddresses.length > 0 && <h3 className='text-text-primary text-lg font-medium'>כתובות נוספות</h3>}
          {otherAddresses.map(address => (
            <AddressPreview key={address.id} address={address} onEdit={() => handleOpenEditAddress(address)} />
          ))}
          <Button
            icon={<AddIcon className='size-3' />}
            variant='ghost'
            size='sm'
            onClick={handleOpenAddAddress}
            className='text-text-link gap-2 text-xs hover:underline'
          >
            הוסף כתובת
          </Button>

          <h4 className='text-text-secondary text-center'>
            שימו ❤️, עריכת הכתובת בעמוד זה אינה מעדכנת את הכתובת עבור חבילות שעבורם כבר שולמו הדמי משלוח.
          </h4>
        </>
      )}

      <EditAddressDialog
        isOpen={isAddressDialogOpen}
        onOpenChange={setIsAddressDialogOpen}
        editingAddress={editingAddress}
        onSuccess={handleAddressDialogSuccess}
      />
    </div>
  )
}
